// icons

import { Icon } from "@iconify/react";
// @mui
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

export default function Iconify({ icon, sx = {}, ...other }) {
  return (
    <Box
      component={Icon}
      icon={icon}
      sx={{ width: "20px", height: "20px", color: "inherit", ...sx }}
      {...other}
    />
  );
}
